import { render, staticRenderFns } from "./CoreSidebar.vue?vue&type=template&id=f5355820&scoped=true"
import script from "./CoreSidebar.vue?vue&type=script&lang=js"
export * from "./CoreSidebar.vue?vue&type=script&lang=js"
import style0 from "./CoreSidebar.vue?vue&type=style&index=0&id=f5355820&prod&lang=less&scoped=true"
import style1 from "./CoreSidebar.vue?vue&type=style&index=1&id=f5355820&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5355820",
  null
  
)

export default component.exports